@let currentUser = currentUser$ | async;
<div class="d-flex" [ngClass]="{'flex-row': !smallScreen, 'flex-column': smallScreen}">
    @if (currentUser) {
        <app-sidenav [currentUser]="currentUser"></app-sidenav>
    }
    <router-outlet></router-outlet>
</div>